import API from '../../api'
import { QueryClient } from 'react-query'

export type ApiKey = {
  id: number,
  maskedKey: string,
  createdAt: string,
  createdByEmail: string,
  lastUsedAt?: string
}

type CreateApiKeyResponse = {
  plaintextKey: string
}

export const ApiKeyUrl = '/web/zapier/api-keys'
export const ApiKeyQueryKey = 'zapierApiKeys'
export const FeatureGrantsQueryKey = 'featureGrants'
export const FeatureGrantsUrl = '/web/feature-grants'
export const ZapierGrant = 'ZAPIER'

export const getApiKeys = async () => {
  return await (await API.get<ApiKey[]>(ApiKeyUrl)).data
}

export const filterDeletedKey = (id: number) => (data:any) => data.filter((x:ApiKey) => x.id !== id)

export const deleteApiKey = async (id: number, queryClient: QueryClient) => {
  await API.delete(`${ApiKeyUrl}/${id}`)
  queryClient.setQueryData(ApiKeyQueryKey, filterDeletedKey(id))
  queryClient.invalidateQueries(ApiKeyQueryKey)
}

export const createApiKey = async (queryClient: QueryClient) => {
  const result = await API.post<CreateApiKeyResponse>(ApiKeyUrl)
  const { plaintextKey } = await result.data
  queryClient.invalidateQueries(ApiKeyQueryKey)
  return plaintextKey
}

export const getFeatureGrants = async () => {
  return await (await API.get<string[]>(FeatureGrantsUrl)).data
}